import React, { useState, useEffect } from "react";
import {
Button,
Modal,
Row,
Col,
Input,
Empty,
Alert,
Dropdown,
Space,
Tag,
Radio,
Tooltip,
Pagination } from
"antd";

import CandidateCard from "./CandidateCard/CandidateCard";
import JobCard from "../../components/JobCard/JobCard";
import BidAmount from "./BidAmount/BidAmount";
import { useDispatch, useSelector } from "react-redux";
import { SellJob } from "./SellJob/SellJob";
import FinalizeBid from "./FinalizeBid/FinalizeBid";
import noJobs from "../../assets/img/EmptyInterviews.png";
import history from "../../routes/history";
import PayCalculation from "./payCalculation";
import Taxtermicon from "../../assets/icons/Taxtermicon.svg";
import { InfoCircleOutlined } from "@ant-design/icons";
import { PERMANENT_JOB } from "../../shared/JobConstants";
import {
getJobListing,
jobListingRESET,
getJobCounts,
savePropsPlaceBid,
keySearchMyGigsLocation,
fetchMyGigsKeySearchSkills,
GetMyGigFilters } from
"../../redux/actions";
import {
SearchOutlined,
LoadingOutlined,
DownOutlined } from
"@ant-design/icons";
import { getImageByStateCode } from "../../pages/CompanyProfile/components/cloudinary";
import {
createBid,
createMultiBid,
updateBid,
clearBidSucess,
fetchInboxMessages,
fetchMessagesCounts } from
"../../redux/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "redux-saga/effects";
import AllGigsFilter from "../../pages/SearchSkillListing/components/AllGigs/AllGigsFilter";
import ChooseGigsButton from "./ChooseGigsButton";
import MobileViewFilter from "./MobileViewFilter";
import { useLocation } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { GIGS_QUERY } from "./gigsQuery";
// New Imports
import {
ApolloClient,
InMemoryCache,
ApolloProvider,
useQuery,
ApolloLink,
gql } from
"@apollo/client";
import { RestLink } from "apollo-link-rest";
import { HttpLink } from "apollo-link-http";
import { setContext } from "@apollo/client/link/context";
import _ from "lodash";
import { calculateTalentNetPay, getTaxCost } from "./utils";
import ChooseGigModal from "../ChooseGigModal/ChooseGigModal";
import { replaceGigWithJob, isNonHC } from "../../shared/helpers";
import "./PlaceBidModal.css";





const skillGigPercentage = 10;





export const DEFAULT_FILTER_VALUES = {
  location: [],
  CityId: [],
  RegionId: [],
  CountryId: [],
  city: null,
  region: [],
  state: [],
  all: "",
  skillListing_type: null,
  budgetType: null,
  ExperienceLevel: [],
  budgetMin: null,
  budgetMax: null,
  NearBy: null,
  hidePrevious: null,
  ProfessionCode: null,
  isPrivateGig: false,
  visa: [],
  visaName: [],
  company: null,
  industry: null,
  skill: [],
  SkillsId: []
};

export function PlaceBidModal(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingBidCreate = useSelector(
  (state) => state.createBidReducers.loading);

  const successBidCreate = useSelector(
  (state) => state.createBidReducers.success);

  const sucessBidUpdate = useSelector(
  (state) => state.updateBidReducers.success);

  const loadingBidUpdate = useSelector(
  (state) => state.updateBidReducers.loading);

  const counts = useSelector((state) => state.manageJobsReducer.counts);
  const jobLoading = useSelector((state) => state.manageJobsReducer.loading);

  const bidData = useSelector((state) => state.createBidReducers.bidData);
  const authTokenValue = useSelector(
  (state) => state.authReducer.user.authToken);

  const updatedBidData = useSelector(
  (state) => state.updateBidReducers.success);


  const createBidError = useSelector((state) => state.createBidReducers.error);

  const updateBidError = useSelector((state) => state.updateBidReducers.error);
  const [getGigs, { loading: loadingGigs, error, data }] = useLazyQuery(
  GIGS_QUERY,
  { fetchPolicy: "no-cache", nextFetchPolicy: "no-cache" });

  const [modalType, setmodalType] = useState("Place a bids");
  const [searchFilters, setSearchFilters] = useState({
    DEFAULT_FILTER_VALUES
  });
  // const [isModalVisible, setIsModalVisible] = useState(props.visible);
  const [sorttype, setsorttype] = useState("$");
  const [searchPublish, setsearchPublish] = useState([]);
  const [selectedGigDetails, setselectedGigDetails] = useState(() => {
    const saved = localStorage.getItem("selectedGigDetails");
    if (saved) {
      return JSON.parse(saved);
    }
    return props?.jobdetails?.length ? props.jobdetails[0] : null;
  });
  const [message, setmessage] = useState();
  const [Comments, setComments] = useState();
  const [rateType, setrateType] = useState("");
  const [rate, setrate] = useState(0.0);
  const [multiBid, setmultiBid] = useState();
  const [currencyType, setcurrencyType] = useState("USD");
  const [contractLength, setcontractLength] = useState("");
  const [idealStartDate, setidealStartDate] = useState();
  const [error1, setError1] = useState("");
  const [error2, setError2] = useState("");
  const [error3, setError3] = useState("");
  const [msgCounter, setMsgCounter] = useState(0);
  const [flag, setFlag] = useState(false);

  const [rateError, setRateError] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [totalLength, setTotalLength] = useState(false);
  const [gigAlert, setGigAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [GigType, setGigType] = useState(false);
  const [taxTermRadio, setTaxTermRadio] = useState("W-2");
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const [windowDimensions, setWindowDimensions] = useState(
  getWindowDimensions());

  const professionCode = JSON.parse(localStorage.getItem("userProfile"));
  const [totalGigs, setTotalGigs] = useState(0);
  useEffect(() => {
    props.Title ? setmodalType(props.Title) : setmodalType("Place a bid");
    props.EditBid === true ?
    setmodalType("Edit Bid") :
    setmodalType("Place a bid");
  }, []);

  useEffect(() => {
    if (modalType === "Choose a gig") {
      handleApplyFilter({
        ...searchFilters,
        _page: currentPage.toString(),
        _perPage: 6,
        _sort: "MOST_RECENT",
        JobOrderStatusName: "Published",
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId
      });
    }
  }, [modalType, currentPage, searchFilters]);

  // useEffect(() => { dispatch(jobListingRESET());},[])
  useEffect(() => {
    if (modalType !== "Place a bid" && (successBidCreate || sucessBidUpdate)) {
      setmodalType("Finalize Bid");
    }
  }, [successBidCreate, sucessBidUpdate]);

  useEffect(() => {
    if (props.extendBilling) {
      setmodalType("Add Estimated Pay");
    }
  }, [props.extendBilling]);

  useEffect(() => {
    setComments(message);
  }, [message]);

  useEffect(() => {
    if (errorAlert || createBidError || updateBidError) {
      setTimeout(() => {
        closemeHandle();
      }, 2000);
    }
  }, [errorAlert, createBidError, updateBidError]);

  useEffect(() => {
    if (contractLength?.length < 0) {
      setError1("Please enter contract length");
    } else {
      setError1(" ");
    }
  }, [contractLength]);

  useEffect(() => {
    if (idealStartDate?.length < 0) {
      setError2("Please select ideal start date");
    } else {
      setError2(" ");
    }
  }, [idealStartDate]);

  useEffect(() => {
    if (props.selectedCandidates?.length == 0 && props.fromMatches != true) {
      props?.placeBidModalVisisblityHandler(false);
    }
  }, [props.selectedCandidates]);

  useEffect(() => {
    if (props.selectedCandidates?.length > 0) {
      if (props.selectedCandidates?.length > 1) {
        setmultiBid(true);
        setrate(0);
      } else {
        setmultiBid(false);
        setrate(
        isNonHC(professionCode?.Professions?.ProfessionCode) ?
        1.0 :
        props.selectedCandidates[0]?.desired_rate);

      }
    }

    // setrate(multiBid? 0 : props?.desired_rate)
  }, [props.selectedCandidates]);

  useEffect(() => {
    setidealStartDate(
    idealStartDate ?
    idealStartDate :
    props.EditBid ?
    props.IdealStartDate :
    "");

    setrateType(rateType ? rateType : props.EditBid ? props.rateType : "");
    setcontractLength(
    contractLength ?
    contractLength :
    props.EditBid ?
    props.IdealConLength :
    "");

    setmessage(message ? message : props.EditBid ? props.Description : "");
    setrate(
    // props.EditBid &&
    isNonHC(professionCode?.Professions?.ProfessionCode) ?
    props.Bid_rate ?? 1 :
    props.EditBid ?
    props.Bid_rate :
    props.desired_rate ?
    props.desired_rate :
    1);

  }, [props]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (props.selectedCandidates?.length > 0) {
      if (props.selectedCandidates?.length > 1) {
        setmultiBid(true);
        setrate(0);
      } else {
        setmultiBid(false);
        setrate(
        isNonHC(professionCode?.Professions?.ProfessionCode) ?
        1.0 :
        props.selectedCandidates[0]?.desired_rate);

      }
    }
    // setrate(multiBid? 0 : props?.desired_rate)
  }, [props.selectedCandidates]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  const jobs = useSelector((state) => state.manageJobsReducer.jobs);
  const publishedJobs = useSelector(
  (state) => state.manageJobsReducer.publishedJobs);

  useEffect(() => {
    dispatch(jobListingRESET());
  }, [successBidCreate, sucessBidUpdate]);

  useEffect(() => {
    if (authTokenValue && props.visible) {
      debounce(
      dispatch(
      getJobListing({
        sorttype: sorttype,
        currentPage: 1,
        pageSize: 20,
        gigType: "Published",
        inputSearch: searchText,
        totalLength: totalLength,
        isPrivate: GigType
      })));


      // debounce(
      //     dispatch(
      //         getJobCounts({
      //           inputSearch: searchText == " " ? "$" : searchText,
      //         })
      //     )
      // );
    }
    setTotalLength(true);
  }, [searchText, props.visible, GigType]); //props.jobs

  // console.log("jobdetails in modal modal: ",props.fromMatches , "and details::",props.jobdetails );

  useEffect(() => {
    if (props?.BidId) {
      dispatch(savePropsPlaceBid(props));
    }
  }, [props?.BidId]);

  useEffect(() => {
    if (data && data?.gigs?.data?.length !== 0) {
      let uniqueJobs = {};
      let filteredJobs = data?.gigs?.data.filter((obj) => {
        if (!uniqueJobs[obj._id]) {
          uniqueJobs[obj._id] = true;
          return true;
        }
        return false;
      });
      setsearchPublish(filteredJobs);
      setFlag(true);
      setTotalGigs(data?.gigs?.aggregate?.totalCount || 0);
    } else {
      setsearchPublish([]);
    }
  }, [data?.gigs?.data, props.visible]);

  const backHandler = () => {
    if (modalType === "Place a bid" || modalType == "Edit Bid") {
      props.placeBidModalVisisblityHandler(false);
      setErrorAlert(false);
      props?.setHidePagePvt(false);
    }
    if (modalType === "Choose a gig") {
      if (props.isEditGig) {
        setmodalType("Edit Bid");
        setErrorAlert(false);
        setSearchFilters(DEFAULT_FILTER_VALUES);
        return;
      }
      setmodalType("Place a bid");
      setErrorAlert(false);
      props?.setHidePagePvt(false);
      setSearchFilters(DEFAULT_FILTER_VALUES);
    }
    if (modalType === "Add Estimated Pay") {
      if (props.fromMatches == true) {
        setmodalType("Place a bid");
        setErrorAlert(false);
      } else {
        setmodalType("");
        showTaxTermModal();
      }
    }
    if (modalType === "Sell your gig") {
      setmodalType("Add Estimated Pay");
      setErrorAlert(false);
    }
    if (modalType === "Finalize Bid") {
      closemeHandle();
      dispatch(fetchInboxMessages("null", "all_conversations", "null", 1, 5));
      setTimeout(() => {
        dispatch(fetchInboxMessages("null", "all_conversations", "null", 2, 5));
      }, 2000);
    }
  };
  const nextHandler = () => {
    const { skillGiggFee, payrollCost, netGrossPay, grossPay } =
    calculateTalentNetPay({
      amount: rate,
      skillGigPercentage,
      payrollCostPercentage:
      getTaxCost(rateType, taxTermRadio, professionCode?.Professions?.ProfessionCode)
    });
    if (modalType === "Place a bid" || modalType == "Edit Bid") {
      if (props.fromMatches == true) {
        setmodalType("Add Estimated Pay");
        setErrorAlert(false);
      } else {
        if (props.isEditGig) {
          setmodalType("Choose a gig");
          setErrorAlert(false);
          setSearchFilters(DEFAULT_FILTER_VALUES);
          setSearchText("");
          setGigType(false);
          return;
        }
        setmodalType("Choose a gig");
        props?.setHidePagePvt(true);
        setErrorAlert(false);
        setSearchFilters(DEFAULT_FILTER_VALUES);
        setSearchText("");
        setGigType(false);
      }
      if (modalType == "Edit Bid" || props?.MessageEditsection) {
        history.push({
          pathname: "/editPlaceBidPage",
          state: { talentName: getUserName() }
        });
      }
    }
    if (modalType === "Choose a gig") {
      // if (isNonHC(userProfile?.Professions?.ProfessionCode)) {
      setmodalType("");
      showTaxTermModal();
      setErrorAlert(false);
      props?.setHidePagePvt(false);
      // }
      // else {
      //   setmodalType("Add Estimated Pay");
      // }
    }
    if (modalType === "Add Estimated Pay") {
      if (rateError === 0) {
        setmodalType("Sell your gig");
      }
      setErrorAlert(false);
    }
    if (modalType === "Sell your gig") {
      var errorCount = 0;

      if (
      contractLength?.length < 1 &&
      selectedGigDetails?.JobOrderTypes?.JobOrderTypeName === "Contract")
      {
        setError1("Please enter contract length");
        errorCount++;
      } else {
        setcontractLength(null);
      }

      if (idealStartDate?.length < 1) {
        setError2("Please select ideal start date");
        errorCount++;
      }

      if (msgCounter < 1) {
        setError3("Please add a message");
        errorCount++;
      }

      if (props.EditBid) {
        if (props?.SkillListingId == null) {
          setErrorAlert(true);
        }
      } else if (!props.EditBid) {
        if (props?.selectedCandidates[0]?.id == null) {
          setErrorAlert(true);
        }
      }

      if (
      !props.multiBid &&
      props.EditBid &&
      // rate >= props.desired_rate &&
      errorCount === 0 &&
      props?.SkillListingId != null)
      {
        dispatch(
        updateBid({
          id: props.BidId,
          GigId: selectedGigDetails?.JobOrderId ?
          selectedGigDetails?.JobOrderId :
          props.jobId,
          SGFees:
          selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" ||
          selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "D"
          // &&
          // isNonHC(professionCode?.Professions?.ProfessionCode) &&
          // userProfile?.Profiles?.Role !== "No billing"
          ? 0.6899 :
          null,
          ActualRate:
          selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" ||
          selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "D"
          // &&
          // userProfile?.Profiles?.Role !== "No billing"
          ? rateType == "Year" ?
          (rate * 0.6899)?.toFixed(2) :
          parseFloat(netGrossPay)?.toFixed(2) :
          rate,
          // SkillListingId: props.selectedCandidates[0].id,
          SkillListingId: props?.SkillListingId,
          Comments: message,
          BudgetType: rateType,
          BidStatusName: "New",
          Rate: rate,
          // contractLength: contractLength,
          IdealTerm: contractLength,
          IdealStartDate: idealStartDate,
          Message: message + "\nBid Amount: " + rate,
          loading: "Submitted",
          IdealTermsName:
          taxTermRadio != "W-2" ? "1099/Corp-to-Corp" : taxTermRadio
        }));

      }
      if (
      !props.multiBid &&
      !props.EditBid &&
      errorCount === 0 &&
      props?.selectedCandidates[0]?.id != null)
      {
        const permanentJob =
        selectedGigDetails?.JobOrderTypes?.JobOrderTypeName === PERMANENT_JOB;
        const IdealTermsName =
        taxTermRadio != "W-2" ? "1099/Corp-to-Corp" : taxTermRadio;
        dispatch(
        createBid(
        selectedGigDetails?.JobOrderId ?
        selectedGigDetails.JobOrderId :
        props.jobId,
        selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" ||
        selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "D"
        // &&
        // isNonHC(professionCode?.Professions?.ProfessionCode) &&
        // userProfile?.Profiles?.Role !== "No billing"
        ? 0.6899 :
        null,
        selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" ||
        selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "D"
        // &&
        // isNonHC(professionCode?.Professions?.ProfessionCode) &&
        // userProfile?.Profiles?.Role !== "No billing"
        ? rateType == "Year" ?
        (rate * 0.6899)?.toFixed(2) :
        parseFloat(netGrossPay)?.toFixed(2) :
        rate,
        props.selectedCandidates[0].id,
        Comments,
        rateType,
        message + "\nBid Amount: " + rate,
        "New",
        rate,
        contractLength,
        idealStartDate,
        permanentJob,
        IdealTermsName));


      }
      if (props.multiBid && errorCount === 0) {
        var candidateListArray = props.selectedCandidates?.map((item) => {
          return {
            GigId: selectedGigDetails?.JobOrderId ?
            selectedGigDetails?.JobOrderId :
            props.jobId,
            SGFees: selectedGigDetails?.JobOrderTypes?.JobOrderTypeId ?
            selectedGigDetails?.JobOrderTypes?.JobOrderTypeId === 1 :
            (selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" ||
            selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode ===
            "D") &&
            !userProfile?.Profiles?.BidCalculationExempted ?
            0.6899 :
            null,
            ActualRate:
            selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" ||
            selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "D"
            // &&
            // isNonHC(professionCode?.Professions?.ProfessionCode) &&
            // userProfile?.Profiles?.Role !== "No billing"
            ? rateType == "Year" ?
            (rate * 0.6899)?.toFixed(2) :
            parseFloat(netGrossPay)?.toFixed(2) :
            rate,
            SkillListingId: item.id,
            Comments: message,
            BudgetType: rateType,
            Message: message + "\nBid Amount: " + rate,
            BidStatusName: "New",
            Rate: rate,
            IdealTerm: contractLength,
            IdealStartDate: idealStartDate,
            IdealTermsName:
            taxTermRadio != "W-2" ? "1099/Corp-to-Corp" : taxTermRadio
          };
        });

        dispatch(
        createMultiBid({
          bids: candidateListArray
        }));

      }
    }

    if (modalType === "Finalize Bid") {
      props.placeBidModalVisisblityHandler(false);
      dispatch(fetchInboxMessages("null", "all_conversations", "null", 1, 5));
      setTimeout(() => {
        dispatch(fetchInboxMessages("null", "all_conversations", "null", 2, 5));
      }, 2000);
      if (props.setSkillListingIds && props.setcheckAllClicked) {
        props.setSkillListingIds([]);
        props.setcheckAllClicked(false);
      }
      if (!(props?.frompdetail || props?.fromMyMatches)) {
        window.location.reload();
      }
      closemeHandle();
    }
  };

  const closemeHandle = () => {
    if (modalType === "Finalize Bid") {
      if (props.EditBid && location.pathname == "/editBidPage") {
        history.push(`/profiledetail/${props?.SkillListingId}`);
      }
      localStorage.removeItem("SelectedSkills");
      localStorage.removeItem("SelectedSkillsSearch");
      props.placeBidModalVisisblityHandler(false);
      if (props.setSkillListingIds && props.setcheckAllClicked) {
        props.setSkillListingIds([]);
        props.setcheckAllClicked(false);
      }
      window.location.reload();
    }
    if (modalType === "Add Estimated Pay" || modalType === "Sell your gig") {
      setmodalType("Choose a gig");
      props?.setHidePagePvt(true);
      setErrorAlert(false);
    } else {
      setmodalType("Place a bid");
      props.placeBidModalVisisblityHandler(false);
      dispatch(clearBidSucess());
      setSearchText("");
      setcontractLength("");
      setmessage("");
      setErrorAlert(false);
    }
    //here
    // dispatch(clearUpdateBidSuccess());
  };
  const fetchMoreData = (value) => {
    // setData(data.concat(Array.from({ length: 20 })))
    setCurrentPage(currentPage + 1);
    dispatch(
    getJobListing({
      sorttype: sorttype,
      currentPage: currentPage + 1,
      gigType: "Published",
      fetchMore: true,
      pageSize: 20,
      isPrivate: GigType
    }));

    // console.log(publishedJobs?.length, "asjfhausi11111");
    // console.log(counts, "asjfhausi2222");
    if (
    publishedJobs?.length ==
    // counts?.totalCount[0]?.expired +
    counts?.totalCount[0]?.published
    // +
    // counts?.totalCount[0]?.deleted
    ) {
      setCurrentPage(1);
      setHasMore(false);
      setTotalLength(true);
    }
    // setTimeout(() => {
    //   dispatch(fetchInboxMessages("null", "all_conversations", "all_bids", 2));
    // }, 500);
  };

  const updateFilters = (data) => {
    const params = {
      value: "",
      body: {
        isPrivateGig: GigType,
        ...data,
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        JobOrderStatusName: "Published"
      }
    };
    dispatch(keySearchMyGigsLocation(params));
    dispatch(fetchMyGigsKeySearchSkills(params));
    // dispatch(GetMyGigFilters(params));
    // dispatch(getJobCounts(params));
  };
  const handleSearch = _.debounce((value) => {
    setSearchText(value);
    handleApplyFilter({
      ...searchFilters,
      all: value,
      search: value,
      _page: "1",
      _perPage: 6,
      _sort: "MOST_RECENT",
      JobOrderStatusName: "Published"
    });
    setCurrentPage(1);
  }, 600);

  const searchHandler = (seacrhText) => {
    // let letters = /^[A-Za-z0-9 @._()\-/*&^%$#@!~`+=|\{}\[\]:;"'<>,.?\\]+$/;
    // if (seacrhText.match(letters) || seacrhText === "") {
    setSearchText(seacrhText);
    // }
    handleSearch(seacrhText);
    setHasMore(false);
  };
  //this useEffect
  useEffect(() => {
    // if(publishedJobs.length===0)
    setsearchPublish(jobs?.publishedGigs);
  }, [jobs?.publishedGigs, props.visible]);

  const handleApplyFilter = (filters = {}) => {
    try {
      const {
        all = "",
        cities,
        countries,
        regions,
        Skills,
        explevel,
        isPrivateGig = false,
        JobOrderTypeName,
        _sort = "MOST_RECENT",
        vms,
        facility,
        _page = currentPage.toString(),
        _perPage = 6
      } = filters;

      getGigs({
        variables: {
          all,
          cities: cities?.length ? cities : undefined,
          countries: countries?.length ? countries : undefined,
          regions: regions?.length ? regions : undefined,
          Skills: Skills?.length ? Skills : undefined,
          isPrivateGig,
          MygigsProfileId:
          userProfile?.MasterAccountId || userProfile?.AccountId,
          SkillListingId: props?.userSKillListing?.skill_listings?.
          SkillListingId ?
          props?.userSKillListing?.skill_listings?.SkillListingId :
          undefined,
          _page,
          _perPage,
          _sort,
          explevel: explevel?.length ? explevel : undefined,
          JobOrderTypeName: JobOrderTypeName || undefined,
          JobOrderStatusName: "Published",
          vms: vms?.length ? vms : undefined,
          facilityIds: facility || undefined
        }
      });
    } catch (error) {
      console.warn("Error applying filters:", error);
    }
  };
  const getUserName = () => {
    try {
      return (
        props?.selectedCandidates?.[0]?.name ||
        props?.userSKillListing?.user_Schema?.Profiles?.PreferredName);

    } catch {
      return null;
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showTaxTermModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onChange = (e) => {
    setTaxTermRadio(e.target.value);
  };

  return (
    <div id="infinite-scroll">
      {modalType !== "" &&
      <Modal
      className="mod"
      open={modalType == "Choose a gig" ? false : props.visible}
      title={
      modalType === "Add Estimated Pay" ?
      selectedGigDetails?.JobOrderTypes?.JobOrderTypeName ==
      "Permanent" ?
      "Add Bid Amount" :
      replaceGigWithJob(modalType) + " Rate" :
      replaceGigWithJob(modalType)}

      bodyStyle={{
        padding:
        modalType === "Choose a gig" ?
        "15px 5px 15px 5px" :
        modalType === "Finalize Bid" ?
        "15px 10px 15px 10px" :
        "15px 5px 15px 20px"
      }}
      style={{ top: "10px" }}
      onOk={nextHandler}
      onCancel={closemeHandle}
      width={windowDimensions.width < 992 ? "99%" : "60%"}
      footer={
      modalType === "Choose a gig" ? null :
      <div className="modalFooterPB">
                <Button
        key="back"
        className="backBtnPlaceBid centerElement textPlaceBid"
        onClick={backHandler}>
          
                  Back
                </Button>

                <button
        style={{
          border: "none",
          cursor:
          !(loadingBidCreate || loadingBidUpdate) &&
          rate < props.desired_rate ?
          "default" :
          "pointer"
        }}
        disabled={
        modalType === "Add Estimated Pay" && rate <= 0 ?
        true :
        false}

        className={`nextBtnPlacedBid nextBtnPlaceBid-nextPadding centerElement textPlacedBid`}
        onClick={nextHandler}>
          
                  {loadingBidCreate || loadingBidUpdate ?
          <LoadingOutlined /> :
          modalType === "Sell your gig" ?
          props.EditBid === true ?
          "Update bid" :

          "Submit Bid" :

          modalType === "Finalize Bid" ?
          "Done" :

          "Next"}
          
                </button>
              </div>}>


        
          {errorAlert || createBidError || updateBidError ?
        <Alert
        style={{ marginBottom: "1%" }}
        message="Something went wrong! Try bidding again."
        type="error"
        // closable
        /> :
        null}

          {modalType === "Place a bid" || modalType == "Edit Bid" ?
        <Row>
              {props.selectedCandidates?.map((item, index) => {
            return (
              <Col
              xs={12}
              sm={12}
              md={12}
              lg={8}
              xl={8}
              style={{ marginBottom: "1%" }}
              key={Math.random()}>
                
                    <CandidateCard
                img={item.img}
                name={item.name}
                item={item}
                title={item.title}
                setSkillListingIds={props?.setSkillListingIds}
                skillListingIds={props?.skillListingIds}
                setSelectedCandidates={props?.setSelectedCandidates}
                setCheckedCandidates={props?.setCheckedCandidates}
                checkedCandidates={props?.checkedCandidates}
                setSkillSetwithIDsAll={props?.setSkillSetwithIDsAll}
                skillSetwithIDsAll={props?.skillSetwithIDsAll}
                experience={item.experience}
                desired_rate={
                item.desired_rate?.$numberDecimal ?
                item.desired_rate?.$numberDecimal :
                item.desired_rate}

                bidType={item.bidType}
                GigType={item.GigType}
                profileType={item.profileType}
                lastActive={item.lastActive}
                closeIcon={true}
                rating={
                item.rating ||
                props?.userSKillListing?.skill_listings?.Profiles?.
                Accounts?.Rating}
                // Use extracted rating if available
                reviews={item.reviews}
                email={item.email}
                userSKillListing={props?.userSKillListing}
                AccountID={item?.AccountId ? item?.AccountId : null}
                MobilePhone={item?.MobilePhone} />
                
                  </Col>);

          })}
            </Row> :
        null}

          {modalType === "Add Estimated Pay" ?
        <>
              <BidAmount
          desiredRate={
          !isNonHC(professionCode?.Professions?.ProfessionCode) ?
          props?.desired_rate !== null ?
          props?.desired_rate :
          1.0 :
          1.0}

          rate={rate}
          setrate={setrate}
          rateType={rateType}
          setrateType={setrateType}
          currencyType={currencyType}
          // setcurrencyType={setcurrencyType}
          multiBid={props.multiBid}
          extendBilling={props.extendBilling}
          setRateError={setRateError}
          EditBid={props.EditBid}
          Bid_rate={props.Bid_rate}
          rateError={rateError}
          professionCode={professionCode?.Professions?.ProfessionCode} />
          
              {["Hour", "Week"].includes(rateType) ?
          <PayCalculation
          amount={rate}
          isPrivateGig={selectedGigDetails?.isPrivate}
          taxTermRadio={taxTermRadio}
          permenantGig={
          selectedGigDetails?.JobOrderTypes?.JobOrderTypeName}

          professionCode={professionCode?.Professions?.ProfessionCode}
          rateType={rateType} /> :

          null}
            </> :
        null}
          {modalType === "Sell your gig" ?
        <SellJob
        // jobId={props.jobId}
        setidealStartDate={setidealStartDate}
        idealStartDate={idealStartDate}
        setcontractLength={setcontractLength}
        contractLength={contractLength}
        message={message}
        setmessage={setmessage}
        setMsgCounter={setMsgCounter}
        error1={error1}
        error2={error2}
        error3={error3}
        setError3={setError3}
        EditBid={props.EditBid}
        selectedGigDetails={selectedGigDetails}
        jobOrderTypeName={
        selectedGigDetails?.JobOrderTypes?.JobOrderTypeName} /> :


        null}

          {modalType === "Finalize Bid" ?
        <FinalizeBid
        rating={
        props?.userSKillListing?.skill_listings?.Profiles?.Accounts?.
        Rating}

        rate={rate}
        rateType={rateType}
        idealStartDate={idealStartDate}
        contractLength={contractLength}
        message={message}
        candidateList={props.selectedCandidates}
        selectedGigDetails={selectedGigDetails}
        jobOrderTypeName={
        selectedGigDetails?.JobOrderTypes?.JobOrderTypeName}

        currencyType={currencyType}
        EditBid={props.EditBid}
        fromMatches={props.fromMatches}
        jobdetails={props.jobdetails} /> :

        null}
        </Modal>}
      

      <div>
        {props.isEditGig ?
        <ChooseGigModal
        modalType={modalType}
        setmodalType={setmodalType}
        windowDimensions={windowDimensions}
        searchText={searchText}
        searchHandler={searchHandler}
        searchPublish={searchPublish}
        fetchMoreData={fetchMoreData}
        hasMore={hasMore}
        loadingGigs={loadingGigs}
        gigAlert={gigAlert}
        setGigAlert={setGigAlert}
        setselectedGigDetails={setselectedGigDetails}
        selectedGigDetails={selectedGigDetails}
        props={props}
        flag={flag}
        history={history}
        getUserName={getUserName}
        nextHandler={nextHandler}
        backHandler={backHandler}
        getImageByStateCode={getImageByStateCode}
        handleApplyFilter={handleApplyFilter}
        setGigType={setGigType}
        GigType={GigType}
        setSearchFilters={setSearchFilters}
        searchFilters={searchFilters} /> :

        modalType === "Choose a gig" ||
        modalType !== "Edit Bid" &&
        props?.fromDetailPage &&
        props?.HidePagePvt ||
        location.pathname === "/editBidPage" ?
        <div className="ChooseGig-cantainer-pvt-tal">
            <div className="ChooseGig-Title-pvt">Choose a job</div>
            <div className="ChooseGig-Section-pvt">
              <Row>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Input
                className="chooseJobSearch-placeBid"
                style={{
                  width: windowDimensions.width > 845 && "330px",
                  marginLeft: windowDimensions.width > 845 && "20px"
                }}
                placeholder="Job title..."
                value={searchText}
                prefix={
                <SearchOutlined className="joblisting-searchicon" />}

                onChange={(e) => searchHandler(e.target.value)}
                allowClear />
                
                </Col>
              </Row>
              <AllGigsFilter
            setGigType={setGigType}
            GigType={GigType}
            searchText={searchText}
            handleApplyFilter={handleApplyFilter}
            windowDimensions={windowDimensions}
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
            defaultParams={{ JobOrderStatusName: "Published" }} />
            
              {gigAlert &&
            <Alert
            style={{
              display: gigAlert ? "" : "none",
              width: "97%",
              marginBottom: "5px"
            }}
            message="Stop Bid Alert"
            description="You have reached the max bid limit (200 bids per day) for this job for today. Try again tomorrow"
            type="warning"
            showIcon
            closable />}

            
              <Row>
                {loadingGigs ?
              <div className="loader-container">
                    <LoadingOutlined className="loader" />
                  </div> :
              searchPublish?.length !== 0 ?
              searchPublish?.map((item, index) => {
                if (
                item.JobOrderStatuses?.JobOrderStatusName !== "Deleted" &&
                item.JobOrderStatuses?.JobOrderStatusName !== "Expired" &&
                item.JobOrderStatuses?.JobOrderStatusName !== "Closed")
                {
                  return (
                    <Col
                    key={index}
                    xs={24}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={8}
                    onClick={() => {
                      if (item.isDisabled) return;
                      if (
                      item?.status?.[3]?.count + (
                      !props.multiBid &&
                      !props.EditBid &&
                      props?.selectedCandidates?.[0]?.id != null ?
                      1 :
                      0) + (
                      props?.multiBid ?
                      props.selectedCandidates?.length :
                      0) >
                      200)
                      {
                        setGigAlert(true);
                        setTimeout(() => {
                          setGigAlert(false);
                        }, 4000);
                      } else {
                        setselectedGigDetails(item);
                        localStorage.setItem(
                        "selectedGigDetails",
                        JSON.stringify(item));

                      }
                    }}>
                      
                          <div
                      className={`jobcard-container ${
                      selectedGigDetails?._id === item?._id ?
                      "ChooseGig-selected-card-pvt" :
                      null
                      } ${item.isDisabled ? "jobcard-container-disabled" : null}`}>
                        
                            <JobCard
                        {...item}
                        key={item?.JobOrderId}
                        img={
                        item?.Regions?.Code !== null &&
                        item?.Cities?.CityName !== null ?
                        getImageByStateCode(
                        item?.Regions?.Code,
                        item?.Cities?.CityName,
                        item?.CompanyName) :

                        ""}

                        budgetType={item?.BudgetTypes?.BudgetTypeCode}
                        RegionCode={item?.Regions?.Code}
                        CityName={item?.Cities?.CityName}
                        id={item?.JobOrderId}
                        location={item.Location?.LocationWithCountry}
                        title={item?.Title}
                        facilityname={item?.FacilityName}
                        budget={item?.BudgetMin}
                        rate={item?.BudgetTypes?.BudgetTypeName}
                        cardFooter={false}
                        cardFooterChoose={true}
                        fromDashboard={true}
                        professionCode={
                        professionCode?.Professions?.ProfessionCode}

                        rating={item?.facilityRating?.rating}
                        WorkplacePolicy={item?.WorkplacePolicy}
                        created={item?.Created}
                        matchedbids={item?.status?.[2]?.count}
                        placedbids={item?.status?.[0]?.count}
                        receivedbids={item?.status?.[1]?.count}
                        isPrivate={item?.isPrivate} />
                        
                          </div>
                        </Col>);

                }
              }) :

              <div className="emptyOtherSearch">
                    {flag ?
                <Empty style={{ weight: "100%" }} /> :

                <div className="employer-profile-body">
                        <div
                  className="employer-profile-body-content"
                  style={{ margin: "10px" }}>
                    
                          <img className="nojobimage" src={noJobs} />
                          <div className="nojobtext">
                            Create a job to let candidates know you're hiring!
                          </div>
                          <button
                    className="postajob-btn"
                    onClick={() => history.push("/postjob")}>
                      
                            <span className="postjobbtn_plussign">+</span>
                            <span className="postjobbtn_text">Post a job</span>
                          </button>
                        </div>
                      </div>}
                
                  </div>}
              
              </Row>
              {data && searchPublish?.length > 0 &&
            <div style={{ marginTop: "20px", textAlign: "center" }}>
                  <Pagination
              current={currentPage}
              pageSize={6}
              total={totalGigs}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false} />
              
                </div>}
            
            </div>
            <div className="ChooseGigsButton-btn">
              <ChooseGigsButton
            talentName={
            !props?.multiBid && props?.fromDetailPage ?
            getUserName() :
            null}

            MessageEditsection={props?.MessageEditsection}
            ConversationId={props?.selectedCandidates}
            path={location.pathname}
            nextHandler={nextHandler}
            backHandler={backHandler}
            selectedGigDetails={selectedGigDetails} />
            
            </div>
          </div> :
        null}
      </div>

      {/* Tax term modal */}

      {/* {
            isNonHC(userProfile?.Professions?.ProfessionCode) ? */}
      <div>
        <Modal
        title={
        <div style={{ height: "20px" }}>
              <p
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#3E3E3E"
          }}>
            
                Choose Tax Term
              </p>
            </div>}

        footer={[
        <div className="footer-div">
              <div>
                <Button
            key="back"
            onClick={() => {
              handleCancel();
              setmodalType("Choose a gig");
              setErrorAlert(false);
              props?.setHidePagePvt(true);
            }}
            className="cancelBtn">
              
                  <span style={{ fontSize: "12px", fontWeight: "600" }}>
                    Back
                  </span>
                </Button>
                ,
              </div>
              <div>
                <Button
            key="submit"
            type="primary"
            onClick={() => {
              handleCancel();
              setmodalType("Add Estimated Pay");
            }}
            className="nextBtn">
              
                  <span style={{ fontSize: "12px", fontWeight: "600" }}>
                    Next
                  </span>
                </Button>
              </div>
            </div>]}

        open={isModalOpen}
        onCancel={() => {
          handleCancel();
          setmodalType("Choose a gig");
          setErrorAlert(false);
          props?.setHidePagePvt(true);
        }}
        width={"740px"}
        bodyStyle={{ height: 248 }}>
          
          <div className="main-div">
            <div className="left-div">
              <span className="Tax-term-text">
                Tax Term <span className="Mandatory-text">(Mandatory)</span>
                {windowDimensions.width <= 786 ?
                <Tooltip
                placement="bottom"
                title={
                <div className="tooltip-div">
                        <ul style={{ marginLeft: "15px" }}>
                          <li className="desc-li">
                            W-2: A tax form used by employers to report
                            employees' annual earnings and tax withholdings to
                            the IRS.
                          </li>
                          <li className="desc-li">
                            Corp-to-Corp (C2C): An arrangement where one
                            corporation contracts with another for services,
                            often used in consulting, with tax responsibilities
                            typically falling on the contracting corporation.
                          </li>
                        </ul>
                      </div>}

                trigger={"click"}
                overlayStyle={{ width: "auto" }}
                overlayInnerStyle={{
                  width: 320,
                  marginTop: "-13px",
                  marginLeft: "-32px",
                  borderRadius: "6px",
                  paddingTop: "10px"
                }}>
                  
                    <span style={{ marginLeft: "8px" }}>
                      <InfoCircleOutlined style={{ color: "#7E7E7E" }} />
                    </span>
                  </Tooltip> :

                ""}
                
              </span>
              <div style={{ paddingTop: "10px" }}>
                <Radio.Group
                accentColor="green"
                onChange={onChange}
                defaultValue={"W-2"}
                buttonStyle="solid">
                  
                  <Radio value={"W-2"}>
                    <span
                    style={{
                      paddingRight: "10px",
                      fontSize: "16px",
                      fontWeight: "400"
                    }}>
                      
                      W-2
                    </span>
                  </Radio>
                  <Radio
                  value={"Corp-to-Corp"}
                  style={{
                    paddingTop: windowDimensions.width <= 786 ? "15px" : ""
                  }}>
                    
                    <span
                    style={{
                      paddingRight: "10px",
                      fontSize: "16px",
                      fontWeight: "400"
                    }}>
                      
                      1099 from Corp-to-Corp
                    </span>
                  </Radio>
                </Radio.Group>
              </div>
            </div>
            {windowDimensions.width <= 786 ?
            <div style={{ width: "500px" }}></div> :

            <div className="right-div">
                <div className="Icon-bulb">
                  <img
                style={{ paddingBottom: "6px" }}
                src={Taxtermicon}
                alt="empty" />
                
                </div>
                <div className="desc-box">
                  <ul>
                    <li className="desc-font">
                      W-2: A tax form used by employers to report employees'
                      annual earnings and tax withholdings to the IRS.
                    </li>
                    <li className="desc-font">
                      1099 from Corp-to-Corp (C2C): An arrangement where one corporation
                      contracts with another for services, often used in
                      consulting, with tax responsibilities typically falling on
                      the contracting corporation.
                    </li>
                  </ul>
                </div>
              </div>}
            
          </div>
        </Modal>
      </div>
      {/* : ""
          } */}
    </div>);

}
const ApolloWrapper = (props) => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const authTokenValue = useSelector(
  (state) => state.authReducer.user.authToken);

  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const ImpersonationId = useSelector(
  (state) => state.authReducer.impersonationId);


  const httpLink = new HttpLink({
    uri: `${BackendApiBaseUrl}/query`
  });

  const authLink = setContext((_, { headers }) => {
    if (ImpersonationId) {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
          impersonationid: ImpersonationId
        }
      };
    } else {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress
        }
      };
    }
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
    defaultOptions: {
      watchQuery: {
        nextFetchPolicy: "no-cache"
      }
    }
  });

  return (
    <ApolloProvider client={client}>
      <PlaceBidModal {...props} />
    </ApolloProvider>);

};

export default ApolloWrapper;